function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import _ from "lodash";
import SettingsButton from "./SettingsButton";
import SettingsDropdown from "./SettingsDropdown";
import SettingsList from "./SettingsList";

const getOptions = ({
  options = []
}) => {
  let _options = [],
      _byValue = {};
  options.map((item, index) => {
    if (typeof item === "string") {
      item = {
        label: item,
        value: item
      };
    }

    _options.push(item);

    _byValue[item.value] = item;
  });
  return {
    options: _options,
    byValue: _byValue
  };
};

const SettingsButtonRef = React.forwardRef((props, ref) => {
  return React.createElement(SettingsButton, _extends({}, props, {
    forwardedRef: ref
  }));
});

const SettingsOptions = (_ref) => {
  let name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "options" : _ref$type,
      onChange = _ref.onChange,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "value", "type", "onChange", "children"]);

  const _React$useState = React.useState(false),
        expanded = _React$useState[0],
        setExpanded = _React$useState[1];

  const anchorRef = React.useRef(null);

  const _getOptions = getOptions(props),
        options = _getOptions.options,
        byValue = _getOptions.byValue;

  const current = byValue[value] || options[0];

  const onToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const onSelect = item => {
    if (onChange) {
      onChange(name, item.value);
    }

    setExpanded(false);
  };

  const onCollapse = () => {
    setExpanded(false);
  };

  return React.createElement(React.Fragment, null, React.createElement(SettingsButtonRef, _extends({}, current, {
    value: value,
    type: type,
    onToggle: onToggle,
    expanded: expanded,
    ref: anchorRef
  })), React.createElement(SettingsDropdown, {
    expanded: expanded,
    anchorEl: anchorRef.current,
    onCollapse: onCollapse
  }, React.createElement(SettingsList, {
    value: current && current.value,
    options: options,
    onSelect: onSelect
  })));
};

export default SettingsOptions;